/**
 * Venba Blog Auto-Linker
 * Scans blog article content and hyperlinks fragrance notes + accords
 * Notes → /search?type=product&q={note}+note
 * Accords → /collections/all?filter.p.m.custom.fragrance_style={accord}
 */
(function () {
  'use strict';

  // Only run on blog article pages
  const article = document.querySelector('.article__body, .rte[data-rte], .shopify-section--article .rte, .shopify-section .rte.cf');
  if (!article) return;

  // Top ~80 fragrance notes to auto-link
  const NOTES = [
    'Bergamot','Vanilla','Musk','Patchouli','Sandalwood','Amber','Jasmine','Rose',
    'Vetiver','Tonka Bean','Pink Pepper','Saffron','Cedarwood','Cardamom','Cinnamon',
    'Lemon','Leather','Cedar','Iris','Benzoin','Oud','Lavender','Orange Blossom',
    'Neroli','Grapefruit','Mandarin','Ylang-Ylang','Tuberose','Violet','Frankincense',
    'Myrrh','Incense','Black Pepper','Ginger','Nutmeg','Clove','Fig','Mint',
    'Green Tea','Basil','Geranium','Magnolia','Peony','Lily','Gardenia','Heliotrope',
    'Sea Salt','Coconut','Raspberry','Cherry','Peach','Apple','Plum','Pear',
    'Tobacco','Suede','Coffee','Chocolate','Caramel','Honey','Praline',
    'Birch','Guaiac Wood','Orris','Labdanum','Ambergris','Vetiver','Oakmoss',
    'Tonka','White Musk','Agarwood','Elemi','Copal'
  ];

  // Accords to auto-link (match fragrance_style filter values)
  const ACCORDS = [
    'Woody','Spicy','Floral','Sweet','Fresh','Oud','Musk','Citrus','Fruity',
    'Leather','Tobacco','Gourmand','Creamy','Aquatic','Powdery','Amber'
  ];

  // Build link URLs
  function noteUrl(note) {
    return '/search?type=product&q=' + encodeURIComponent(note) + '+note';
  }
  function accordUrl(accord) {
    return '/collections/all?filter.p.m.custom.fragrance_style=' + encodeURIComponent(accord);
  }

  // Process text nodes inside the article
  function processNode(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      var text = node.textContent;
      if (!text.trim()) return;

      // Skip if parent is already a link
      if (node.parentElement && node.parentElement.closest('a')) return;

      // Build combined pattern: accords first (higher priority), then notes
      var allTerms = [];
      ACCORDS.forEach(function (a) {
        allTerms.push({ term: a, url: accordUrl(a), type: 'accord' });
      });
      NOTES.forEach(function (n) {
        // Skip if already an accord (e.g., "Leather" is both)
        if (ACCORDS.indexOf(n) === -1) {
          allTerms.push({ term: n, url: noteUrl(n), type: 'note' });
        }
      });

      // Sort by length descending so "Orange Blossom" matches before "Orange"
      allTerms.sort(function (a, b) { return b.term.length - a.term.length; });

      var replaced = false;
      var html = text;

      // Track which positions are already replaced to avoid nested replacements
      allTerms.forEach(function (item) {
        // Match whole word only, case-insensitive first occurrence
        var regex = new RegExp('\\b(' + item.term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')\\b', 'i');
        if (regex.test(html) && html.indexOf('<a ') === -1) {
          html = html.replace(regex, '<a href="' + item.url + '" class="venba-autolink venba-autolink--' + item.type + '" title="Explore ' + item.term + ' fragrances">$1</a>');
          replaced = true;
        }
      });

      if (replaced) {
        var span = document.createElement('span');
        span.innerHTML = html;
        node.parentNode.replaceChild(span, node);
      }
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      // Skip links, scripts, styles, headings
      var tag = node.tagName.toLowerCase();
      if (tag === 'a' || tag === 'script' || tag === 'style' || tag === 'code' || tag === 'pre') return;

      // Process child nodes (copy to array first since we modify DOM)
      var children = Array.prototype.slice.call(node.childNodes);
      children.forEach(processNode);
    }
  }

  // Run after DOM is ready
  processNode(article);
})();
